
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Sr. Consultant (Multimedia)
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> 1.Essential qualification B.E. Computer Science Engineering (or) MBA (or) M.Sc. Electronic media (or) M.Sc. Visual Communication (or) any equivalent master degree from recognised university/institutes.</p>
              <p> 2.Conversation skill coupled with the communication skill in English & Hindi language is preferable.</p>
            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <!-- <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Age limit: </h3>
              <p> Candidates should be below 45 years of age as on the date of advertisement
</p>

            </div>
          </div>
        </div> -->
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Vacancy: </h3>
              <p> 1-Post
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>SALARY COMPENSATION:</h3>
        <p>1.Selected candidates will be paid monthly compensation of INR 60,000-65,000 rupees for 3+ years of experience and INR 70,000-75,000 for 4+ years of experience </p>
        <p>2.Any other further additional allowances are not applicable</p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 24th July 2023 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>PREFERRED EXPERIENCE:</h3>
		
        <p> <span class="step_no">1</span>Minimum 3 to 5 years’ experience in full life cycle project management related to e-learning content.</p>
        <p> <span class="step_no">2</span>Should have 3 years’ manager level experience in e-learning or animation firms or media houses </p>
        <p> <span class="step_no">3</span>Minimum 1 project with any Central Government / State Government / Universities or Institutes of Higher Education (Established by a status) / Education Technology Companies on e-learning projects</p>
			



      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>JOB DESCRIPTION:</h3>
		
        <p> <span class="step_no">1</span>Project planning and Management. Management of team, vendors, SMEs and Technical expert’s. Risk identification and conflict management. Creating weekly and monthly reports.</p>
        <p> <span class="step_no">2</span>Lead the project’s implementation as per the requirement & ensure the goals for the e-Learning strategy are achieved, through evaluation at different level</p>
        <p> <span class="step_no">3</span>Monitor project progress and make necessary adjustments to ensure successful execution.</p>
		<p> <span class="step_no">4</span>Foster effective communication among project team members and stakeholders</p>
    	<p> <span class="step_no">5</span>Establish quality standards and ensure project deliverables meet or exceed the defined criteria.</p>
        <p> <span class="step_no">6</span>Conduct regular inspections and assessments to monitor the quality of project outputs</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>OTHER TERMS AND CONDITIONS:</h3>
        
			
<p><span class="step_no">1</span>Candidates who fulfil the required eligibility conditions shall bring their original certificate other documents on the interview date and time, educational certificates and experience letters etc.,
</p>
<p><span class="step_no">2</span>Candidate attending the skill test & interview would not be paid TA/DA</p>
<!-- <p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p> -->

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>Annual contract with performance-based extension of contract as per project requirement</p>

           

    
          </div>
        </div>
      </div>
      <!-- feature box close -->

 <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>

           

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p>Chennai - 1 Post </p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
 <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>QUALIFICATIONS</h3>
       		<p>1.Essential qualification B.E. Computer Science Engineering (or) MBA (or) M.Sc. Electronic media (or) M.Sc. Visual Communication (or) any equivalent master degree from recognized university/institutes</p>
            <p>2.Conversation skill coupled with the communication skill in English & Hindi language is preferable</p>
      </div>
    </div>
  </div> -->
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>

